import { useEffect, useRef, useState } from 'react';

const useDebounce = () => {
  const [disable, setDisable] = useState(false);

  const timer = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    return () => {
      timer.current && clearTimeout(timer.current);
    };
  }, []);

  const handleDebounce = (fnc: () => void) => {
    if (!disable) {
      fnc && fnc();
      setDisable(true);
      timer.current = setTimeout(() => {
        setDisable(false);
      }, 1000);
    }
  };

  return {
    handleDebounce,
  };
};

export default useDebounce;
